import React from "react";
import { RootStack } from "src/navigation/RootNavigation";
import withSuspense from "src/navigation/withSuspense";
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
const Notes = withSuspense(React.lazy(() => import('./screens/Notes')));
const LLMChat = withSuspense(React.lazy(() => import('./screens/LLMChat')));
export const renderAdminStackRoutes = ({}) => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "Admin_Home", component: Home }),
        React.createElement(RootStack.Screen, { name: "Admin_Notes", component: Notes }),
        React.createElement(RootStack.Screen, { name: "Admin_LLMChat", component: LLMChat })));
};
